import { useEffect, useState } from 'react'
import Map from '../../components/mapcompo/Mapcompo'
import axios from 'axios'
import TripLocationMap from '../../components/mapcompo/TripLocationMap';

const latLongArray = [
    [25.55596262, 94.14661435],
    [25.59085835, 94.13405595],
    [25.60999459, 94.13665424],
    [25.63199098, 94.11817751],
    [25.64045006, 94.11875491],
    [25.66725484, 94.13463335],
    [25.69249268, 94.14459346],
    [25.70536972, 94.12640543],
    [25.73072952, 94.11586792],
    [25.74867318, 94.11456878],
    [25.74854316, 94.09753554],
    [25.73241998, 94.07328484],
    [25.70354881, 94.07877012],
    [25.6891106, 94.08901892],
    [25.67753275, 94.04816804],
    [25.65931813, 94.06462387],
    [25.63628566, 94.09219461],
    [25.63472398, 94.10013383],
    [25.62040759, 94.09724684],
    [25.6083024, 94.10186602],
    [25.57386893, 94.10477264],
    [25.55589895, 94.13465297],
    [25.55537804, 94.14952096],
    [25.56175902, 94.15183055]
];

const Bookinglocations = () => {
    const [tripslocation, setTripslocation] = useState([]);
    const [originalData, setOriginalData] = useState(null);
    const [filterType, setFilterType] = useState('all'); // 'all', 'today', 'date', 'range'
    const [availableDates, setAvailableDates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Count tracking
    const [totalTripsAllTime, setTotalTripsAllTime] = useState(0);
    const [totalGeohashesAllTime, setTotalGeohashesAllTime] = useState(0);

    // Get min and max dates for input restrictions
    const minDate = availableDates.length > 0 ? availableDates[availableDates.length - 1] : '';
    const maxDate = availableDates.length > 0 ? availableDates[0] : '';

    useEffect(() => {
        const fetch = async () => {
            try {
                setLoading(true);
                setError(null);

                const res = await axios.get(`${process.env.REACT_APP_URL}/api/rides/tripslocation`, { withCredentials: true });
                console.log(res.data, "tripslocation");

                // Store original data with dates for filtering
                setOriginalData(res.data);

                // Extract available dates
                if (res.data.geohashCounts && Array.isArray(res.data.geohashCounts)) {
                    const dates = res.data.geohashCounts.map(group => group.date).sort().reverse();
                    setAvailableDates(dates);

                    // Set initial data (all data)
                    const flatGeohashes = convertToFlatFormat(res.data);
                    setTripslocation(flatGeohashes);

                    // Calculate total counts for all time
                    calculateTotalCounts(res.data);
                } else {
                    // Fallback to original format if it's already flat
                    setTripslocation(res.data.geohashCounts || []);
                }
            } catch (error) {
                console.log("Error fetching trips location:", error);
                setError("Failed to load trip locations");
            } finally {
                setLoading(false);
            }
        };
        fetch();
    }, []);

    // Calculate total trips and geohashes for all time
    const calculateTotalCounts = (data) => {
        if (!data.geohashCounts || !Array.isArray(data.geohashCounts)) return;

        let totalTrips = 0;
        let totalGeohashes = new Set();

        data.geohashCounts.forEach(dateGroup => {
            if (dateGroup.geohashes && Array.isArray(dateGroup.geohashes)) {
                dateGroup.geohashes.forEach(geohashItem => {
                    if (geohashItem && geohashItem.geohash) {
                        totalTrips += geohashItem.count;
                        totalGeohashes.add(geohashItem.geohash);
                    }
                });
            }
        });

        setTotalTripsAllTime(totalTrips);
        setTotalGeohashesAllTime(totalGeohashes.size);
    };

    // Function to convert grouped data to flat format
    const convertToFlatFormat = (data) => {
        if (!data.geohashCounts || !Array.isArray(data.geohashCounts)) {
            return [];
        }

        const allGeohashes = [];

        data.geohashCounts.forEach(dateGroup => {
            if (dateGroup.geohashes && Array.isArray(dateGroup.geohashes)) {
                dateGroup.geohashes.forEach(geohashItem => {
                    if (geohashItem && geohashItem.geohash) {
                        allGeohashes.push({
                            ...geohashItem,
                            date: dateGroup.date
                        });
                    }
                });
            }
        });

        // Aggregate counts by geohash
        const geohashCountsMap = allGeohashes.reduce((acc, item) => {
            if (!acc[item.geohash]) {
                acc[item.geohash] = { ...item, count: 0 };
            }
            acc[item.geohash].count += item.count;
            return acc;
        }, {});

        // Convert back to array format and sort
        return Object.values(geohashCountsMap)
            .sort((a, b) => b.count - a.count);
    };

    // Function to filter by specific date
    const filterByDate = (date) => {
        if (!originalData || !originalData.geohashCounts) return [];

        const dateData = originalData.geohashCounts.find(dateGroup => dateGroup.date === date);

        if (dateData && dateData.geohashes) {
            return dateData.geohashes
                .filter(geohashItem => geohashItem && geohashItem.geohash)
                .sort((a, b) => b.count - a.count);
        }

        return [];
    };

    // Function to filter by date range
    const filterByDateRange = (start, end) => {
        if (!originalData || !originalData.geohashCounts) return [];

        const filteredGeohashes = [];
        const geohashCountsMap = {};

        originalData.geohashCounts.forEach(dateGroup => {
            if (dateGroup.date >= start && dateGroup.date <= end && dateGroup.geohashes) {
                dateGroup.geohashes.forEach(geohashItem => {
                    if (geohashItem && geohashItem.geohash) {
                        if (!geohashCountsMap[geohashItem.geohash]) {
                            geohashCountsMap[geohashItem.geohash] = { ...geohashItem, count: 0 };
                        }
                        geohashCountsMap[geohashItem.geohash].count += geohashItem.count;
                    }
                });
            }
        });

        return Object.values(geohashCountsMap).sort((a, b) => b.count - a.count);
    };

    // Function to get all data (no filter)
    const getAllData = () => {
        if (!originalData) return [];

        if (originalData.geohashCounts && Array.isArray(originalData.geohashCounts)) {
            return convertToFlatFormat(originalData);
        } else {
            return originalData.geohashCounts || [];
        }
    };

    // Validate if date exists in available dates
    const isValidDate = (date) => {
        return availableDates.includes(date);
    };

    // Apply filters
    const applyFilter = () => {
        let filteredData = [];

        switch (filterType) {
            case 'today':
                const today = new Date().toISOString().split('T')[0];
                filteredData = filterByDate(today);
                break;
            case 'date':
                if (selectedDate && isValidDate(selectedDate)) {
                    filteredData = filterByDate(selectedDate);
                } else {
                    alert('Please select a valid date from the available range');
                    return;
                }
                break;
            case 'range':
                if (startDate && endDate) {
                    if (!isValidDate(startDate) || !isValidDate(endDate)) {
                        alert('Please select valid dates from the available range');
                        return;
                    }
                    if (startDate > endDate) {
                        alert('Start date cannot be after end date');
                        return;
                    }
                    filteredData = filterByDateRange(startDate, endDate);
                }
                break;
            case 'all':
            default:
                filteredData = getAllData();
                break;
        }

        setTripslocation(filteredData);
    };

    // Calculate current filter stats
    const getCurrentStats = () => {
        const totalTrips = tripslocation.reduce((sum, item) => sum + item.count, 0);
        const totalGeohashes = tripslocation.length;

        return { totalTrips, totalGeohashes };
    };

    const { totalTrips, totalGeohashes } = getCurrentStats();

    // Get today's date for display
    const getTodayDate = () => {
        return new Date().toISOString().split('T')[0];
    };

    // Reset filters
    const resetFilters = () => {
        setFilterType('all');
        setSelectedDate('');
        setStartDate('');
        setEndDate('');
        const allData = getAllData();
        setTripslocation(allData);
    };

    // Handle date input change with validation
    const handleDateChange = (setter) => (e) => {
        const value = e.target.value;
        setter(value);
    };

    const rad2 = [
        { lat: 25.658694, lng: 94.099027 },
        { lat: 25.705101293928085, lng: 94.10628577758122 },
        { lat: 25.688935806892648, lng: 94.09843680497741 },
        { lat: 25.67419, lng: 94.10864 }
    ];

    const fetchrideStats55 = async () => {
        try {
            const url = `${process.env.REACT_APP_URL}/api/rides/rideStats55`;
            const response = await axios.get(url, { withCredentials: true });
            console.log(response.data, "ride stats55555555555555555555555");
        } catch (error) {
            console.log("API correct??", error);
        }
    };

    useEffect(() => {
        fetchrideStats55();
    }, []);

    // Show loading state
    if (loading) {
        return (
            <div style={{ width: '100%', height: '100%', padding: '10px 10px 10px 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div>Loading trip locations...</div>
            </div>
        );
    }

    // Show error state
    if (error) {
        return (
            <div style={{ width: '100%', height: '100%', padding: '10px 10px 10px 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ color: 'red' }}>{error}</div>
            </div>
        );
    }



    return (
        <div style={{ width: '100%', height: '100%', padding: '10px 10px 10px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h1 style={{ margin: 0, marginBottom: '10px' }}>Booking Location</h1>
            </div>

            {/* Filter Controls */}
            <div style={{ marginBottom: '10px', padding: '15px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center', marginBottom: '10px' }}>
                    {/* Filter Type Selection */}
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <label style={{ fontSize: '14px', fontWeight: 'bold' }}>Filter by:</label>
                        <select
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                            style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc' }}
                        >
                            <option value="all">All Dates</option>
                            <option value="today">Today</option>
                            <option value="date">Specific Date</option>
                            <option value="range">Date Range</option>
                        </select>
                    </div>

                    {/* Specific Date Selection */}
                    {filterType === 'date' && (
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <label style={{ fontSize: '14px' }}>Select Date:</label>
                            <input
                                type="date"
                                value={selectedDate}
                                onChange={handleDateChange(setSelectedDate)}
                                min={minDate}
                                max={maxDate}
                                style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc' }}
                            />
                            <div style={{ fontSize: '12px', color: '#666' }}>
                                Available: {minDate} to {maxDate}
                            </div>
                        </div>
                    )}

                    {/* Date Range Selection */}
                    {filterType === 'range' && (
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <label style={{ fontSize: '14px' }}>From:</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={handleDateChange(setStartDate)}
                                    min={minDate}
                                    max={maxDate}
                                    style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc' }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <label style={{ fontSize: '14px' }}>To:</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={handleDateChange(setEndDate)}
                                    min={minDate}
                                    max={maxDate}
                                    style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc' }}
                                />
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>
                                Range: {minDate} to {maxDate}
                            </div>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                            onClick={applyFilter}
                            style={{
                                padding: '6px 16px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            Apply Filter
                        </button>
                        <button
                            onClick={resetFilters}
                            style={{
                                padding: '6px 16px',
                                backgroundColor: '#6c757d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            Reset
                        </button>
                    </div>
                </div>

                {/* Current Filter Display */}
                <div style={{ fontSize: '14px', color: '#666', fontWeight: 'bold' }}>
                    {filterType === 'today' && `Showing: Today (${getTodayDate()})`}
                    {filterType === 'date' && selectedDate && `Showing: ${selectedDate}`}
                    {filterType === 'range' && startDate && endDate && `Showing: ${startDate} to ${endDate}`}
                    {filterType === 'all' && 'Showing: All Dates'}
                </div>
            </div>

            {/* Statistics Display */}
            <div style={{ marginBottom: '10px', padding: '12px', background: '#e9ecef', borderRadius: '6px' }}>
                <div style={{ display: 'flex', gap: '20px', fontSize: '14px', flexWrap: 'wrap' }}>
                    <div>
                        <strong>Current View:</strong> {totalGeohashes} geohashes, {totalTrips} trips
                    </div>
                    <div>
                        <strong>All Time:</strong> {totalGeohashesAllTime} geohashes, {totalTripsAllTime} trips
                    </div>
                    <div>
                        <strong>Available Dates:</strong> {minDate} to {maxDate} ({availableDates.length} days)
                    </div>
                </div>
            </div>

            <TripLocationMap
                polypoints={[]}
                locations={{}}
                createZone={false}
                tripslocation={Array.isArray(tripslocation) ? tripslocation : []}
            />
        </div>
    )
}

export default Bookinglocations